import React, { createContext, useContext, ReactNode } from 'react';
import { useSignalR } from '../hooks/useSignalR.ts';

interface SignalRContextType {
  connection: signalR.HubConnection | null;
  isConnected: boolean;
  error: string | null;
}

const SignalRContext = createContext<SignalRContextType | undefined>(undefined);

export const SignalRProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const signalR = useSignalR();

  return (
    <SignalRContext.Provider value={signalR}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalRContext = () => {
  const context = useContext(SignalRContext);
  if (context === undefined) {
    throw new Error('useSignalRContext must be used within a SignalRProvider');
  }
  return context;
}; 